<body>
    <!-- HEADER -->
    <div class="header">
        <h2 translate> watch.intergrate_modal.title</h2>
    </div>
    <!-- CONTENT -->
    <div class="content flex-column">

        <div class="flex-row auto-start">
            <input type="checkbox"
             [checked]="autoStartPreference.getValue()" 
             (change)="toggleAutoStartPref()"
             class="checkbox"/>
            <span class="label" translate>watch.intergrate_modal.auto_start_checkbox</span>
        </div>

        <div class="flex-column gap-sm size-select-menu">
            <span class="label" translate>watch.intergrate_modal.size</span>
            <!-- SELECT -->
            <div ngbDropdown display="dynamic" placement="bottom-left" class="selected-size">
                <button ngbDropdownToggle role="button" class="size-select">
                    <span>&nbsp;{{currentSize.getValue().w}} X {{currentSize.getValue().h}} </span>
                </button>
                <div class="btn-dropdown" ngbDropdownMenu aria-labelledby="sizeDropdown">
                    <ng-container *ngFor="let size of sizes">
                        <a ngbDropdownItem *ngIf="size !== currentSize" (click)="currentSize.next(size)">
                            <span>&nbsp;{{size.w}} X {{size.h}} </span>
                        </a>
                    </ng-container>
                </div>
            </div>
        </div>

        <div class="flex-column gap-sm">
            <span class="label" translate>watch.intergrate_modal.label</span>
            <!-- CODE -->
            <div class="code-content" (click)="copyIFrameUrl()" pRipple>
                {{this.iFrameUrl | async}}
            </div>
            <span class="hint" translate>watch.intergrate_modal.hint</span>
        </div>

    </div>

</body>